import React from 'react';
import { Table, Text, TableVariants } from '@clockout-dev/design-elements';
import { formatCurrency } from '../../../utils/numbers';
import styles from './styles/user-summary-table.module.scss';

const TRANSFER_TYPE_LABEL = {
    instant: 'Instant',
    standard: 'Standard',
};

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (name) => <Text as="span" size="s" className={styles.cellStrong}>{name || '—'}</Text>,
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        align: 'right',
        render: (amount) => <Text as="span" size="s" className={styles.cellMuted}>{formatCurrency(amount)}</Text>,
    },
    {
        title: 'Type',
        dataIndex: 'transferType',
        key: 'transferType',
        render: (type) => (
            <Text as="span" size="s" className={styles.cellMuted}>
                {TRANSFER_TYPE_LABEL[type] || type || '—'}
            </Text>
        ),
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        render: (value) => <Text as="span" size="s" className={styles.cellMuted}>{value}</Text>,
    },
];

function TransactionSummaryTable({ rows = [], loading = false, pageInfo = null, onTableChange }) {
    return (
        <Table
            variant={TableVariants.HISTORY}
            columns={columns}
            dataSource={rows}
            loading={loading}
            pageInfo={pageInfo || null}
            onChange={onTableChange}
            saveSearchParams
            rowKey="key"
            emptyDescription="No advances for this period."
        />
    );
}

export default TransactionSummaryTable;
